import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ImageZoom from '../ImageZoom';

const useStyles = makeStyles({
  imageContainer: {
    width: 60,
    height: 50,
    composes: 'flexRow center',
    overflow: 'hidden',
    display: 'inline-block',
  },
  image: {
    width: '100%',
  },
  zoomable: {
    cursor: 'zoom-in',
  },
});

const CustomImageCell = (props) => {
  const { value, zoomSrc, zoomContent, zoomSize, label, className, children } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  // The image shown big on click: `zoomSrc` when given (a cell drawing its own preview), else `value`;
  // `zoomContent` when the cell shows a drawing rather than an image.
  const src = zoomSrc || value;
  const zoomable = !!(src || zoomContent);

  const openZoom = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <div className={classNames(classes.imageContainer, { [classes.zoomable]: zoomable }, className)} onClick={zoomable ? openZoom : undefined} title={zoomable ? label : undefined} data-zoom={zoomable ? '' : undefined}>
        {value ? <img className={classes.image} alt="" src={value} /> : children}
      </div>
      {zoomable && (
        <ImageZoom src={src} label={label} size={zoomSize} open={open} onClose={() => setOpen(false)}>
          {zoomContent}
        </ImageZoom>
      )}
    </>
  );
};

CustomImageCell.propTypes = {
  value: PropTypes.any,
  zoomSrc: PropTypes.string,
  zoomContent: PropTypes.node,
  zoomSize: PropTypes.shape({ w: PropTypes.number, h: PropTypes.number }),
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default CustomImageCell;
